<template>
  <div class="LHome">
    <div>
      <Header v-if="domain === 1"></Header>
      <ReportHeader v-else></ReportHeader>
      <router-view/>
    </div>
    <div>
      <Footer></Footer>
    </div>
    <loading v-show="loading"></loading>
    <LogAndReg ref="logAndReg" v-show="loginPop"></LogAndReg>
    <AllSilderPc ref="allSilder"></AllSilderPc>
  </div>
</template>

<script>
import Loading from "base/loading/loading";
import Footer from "base/footer/pageFooter2";
import Header from "base/header/pageHeader";
import ReportHeader from "base/header/ReportHeader";
import LogAndReg from "views/pc/login/LogAndReg";
import { mapGetters } from "vuex";
export default {
    name: 'LHome',
    computed: {
        ...mapGetters([
            'loading',
            'loginPop',
            'domainlist'
        ])
    },
    data() {
        return {
            domain: 1
        }
    },
    mounted() {
      // console.log('this.domainlist:',this.domainlist)
        if(window.location.hostname.indexOf('ke.capwhale.com')>=0){
          this.domain = 1
        } else if(window.location.hostname.indexOf('report.capwhale.com')>=0){
          this.domain = 2
        } else {
          this.domain = 3
        }
    },
    components: {
        Loading,
        Footer,
        Header,
        ReportHeader,
        LogAndReg
    }
}
</script>

<style lang="scss" type="text/scss">
@import url("../common/scss/common.scss");
.LHome {
  min-height: 100vh;
  height: 100vh;
  // overflow-x: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  // background-color: #F8F8F8FF;
}

.el-message__icon{
  font-size: 14px;
}
// .PHome::-webkit-scrollbar {
//     display: none;
// }

</style>
